// Do NOT add "use client" to this file
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var ProductTileContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: "relative flex flex-col",
        "data-test-id": "product-tile",
        children: children
    });
};
